import { useRegistrationStore } from '../../hooks';
import { EnvironmentRegistrationModalView } from '../../components/EnvironmentRegistrationModalView';

export const EnvironmentRegistrationModal = () => {
  const registrationStore = useRegistrationStore();

  return <EnvironmentRegistrationModalView {...registrationStore} />;
};
